import { render, staticRenderFns } from "./SavedListGrid.vue?vue&type=template&id=f88d2c58&"
import script from "./SavedListGrid.vue?vue&type=script&lang=js&"
export * from "./SavedListGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports